import MicrosoftAppSettings from './MicrosoftAppSettings'
import {
  deleteMicrosoftSharePointAppConnection,
  getMicrosoftSharePointAppStatus,
  saveMicrosoftSharePointAppConnection,
} from '../service/microsoft'

export default function MicrosoftSharePointAppSettings() {
  return (
    <MicrosoftAppSettings
      config={{
        titleKey: 'microsoftSharePointAppSettingsTitle',
        hintKey: 'microsoftSharePointAppSettingsHint',
        clientIdLabelKey: 'microsoftSharePointAppClientId',
        tenantIdLabelKey: 'microsoftSharePointAppTenantId',
        clientSecretLabelKey: 'microsoftSharePointAppClientSecret',
        redirectUriLabelKey: 'microsoftSharePointAppRedirectUri',
        connectedKey: 'microsoftSharePointAppConnected',
        notConnectedKey: 'microsoftSharePointAppNotConnected',
        saveKey: 'microsoftSharePointAppSave',
        disconnectKey: 'microsoftSharePointAppDisconnect',
        allFieldsRequiredKey: 'microsoftSharePointAppAllFieldsRequired',
        savedMessageKey: 'microsoftSharePointAppConnectionSaved',
        idPrefix: 'microsoft-sharepoint-app',
        tenantIdRequired: false,
        guide: {
          href: '/DATASecurityKYC-MicrosoftSharepointAnmeldung.docx',
          labelKey: 'microsoftSsoGuide',
        },
        loadStatus: getMicrosoftSharePointAppStatus,
        saveConnection: saveMicrosoftSharePointAppConnection,
        deleteConnection: deleteMicrosoftSharePointAppConnection,
      }}
    />
  )
}
